import MapSearchResult from 'components/maps/MapSearchResult';

export default MapSearchResult;
